import React, { useState } from 'react';
import useMyTrueStoriesData from "../../hooks/useMyTrueStoriesData";
import Loading from "../../components/Loading";
import Header from "../../global/Header";
import GridContainer from "../../global/GridContainer";
import LegalText from "../../components/LegalText";
import MyStoryTile from "../../components/MyStoryTile";
import ButtonSecondary from "../../components/ButtonSecondary";

export default function MyTrueStories() {
  const [ updater, setUpdater ] = useState(0);
  const [ loading, error, stories ] = useMyTrueStoriesData(updater);
  // calling this function will trigger data fetching;
  const updateData = setUpdater.bind(null, updater + 1);

  if (loading) return (
  <main className="detail pt125 mih100vh">
    <Loading/>
  </main>
  );

  if (error) return (
  <main className="detail pt125 mih100vh">
    <p>Error: {error.message}</p>
  </main>
  );

  if (stories.length === 0) return (
    <main className="detail mih100vh">
      <GridContainer className="pt125 tac">
        <h1 className="fz64 fz32@sm lh0.77 fw600 ff-pgc mt60 mb32 mt0@sm">
          True Stories
        </h1>

        <p className="fz16 fz14@sm fw500 lh1.5">Looks like you don't have True Stories. Write one now and get 100 points!</p>

        <div className="df jcc mt40">
          <ButtonSecondary
            className="w100%@sm c-red w250 my-true-stories__share"
            to="/apps/truestories/story/share"
          >
            Create a True Story
          </ButtonSecondary>
        </div>

      </GridContainer>
    </main>
    )

  return (
  <main className="my-true-stories bgc-white mb80 mt40 mt24@md">
    <GridContainer className="pt125 pt24@md">
      <section className="my-true-stories__content">

        <ol className="my-true-stories__list dg aic lstn g24 gcolm3 gcolm2@md gcolm1@smx">
          {stories.map(story => (
            <li className="my-true-stories__item w100%" key={story.ID}>
              <MyStoryTile
                created={story.createdDate}
                status={story.status}
                ID={story.ID}
                storyId={story._id}
                petName={story.petName}
                images={story.images}
                updateData={updateData}
              />
            </li>
          ))}
        </ol>

      </section>
    </GridContainer>
  </main>
  )
}
